/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { object, func } from 'prop-types';
import {
  Form,
  FormButton,
  FormDropdown,
  FormEmail,
  FormNumber,
  FormTextField
} from '@thd-olt-component-react/form';

const WrappedFields = (props) => {

  const {
    onSubmit,
    workshopsData
  } = props;

  const formatDate = (dateStr) => {
    const date = new Date(Date.parse(dateStr));
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' });
    const day = date.getDate();

    return `${month} ${day}, ${year}`;
  };

  return (
    <Form onSubmit={onSubmit} className="sui-mt-6 sui-grid sui-grid-cols-1 sui-gap-4">
      <FormTextField
        name="name"
        label="Parent / Guardian Name"
        placeholder="Name"
        required
        validate={
          {
            regex: /^[a-zA-Z\s-]*[a-zA-Z]{2,}[a-zA-Z\s-]*$/,
            regexMessage: 'A valid name with first and last name is required',
            typeError: 'error'
          }
        }
      />

      <FormEmail
        name="email"
        label="Email"
        placeholder="johndoe@john.doe"
        required
      />

      <FormNumber
        name="participants"
        label="Number of Kids Attending"
        placeholder="0"
        required
        min={1}
      />

      <FormDropdown
        name="workshop"
        label="Choose Your Workshop"
        options={workshopsData?.workshops?.map((workshop) => {
          return (
            { value: workshop, label: `${workshop?.name} ${formatDate(workshop?.startDate)}` }
          );
        })}
        required
      />

      <FormButton
        variant="primary"
        label="Register"
        className="sui-grid sui-grid-cols-1 sui-justify-items-end sui-gap-4"
      />
    </Form>
  );
};

WrappedFields.propTypes = {
  onSubmit: func.isRequired,
  workshopsData: object.isRequired
};

export default WrappedFields;
